import Swiper, {Scrollbar} from '../../../../node_modules/swiper/swiper-bundle';

const articleNav = {};


articleNav.swiperSlider = function () {
	const $articleNav = $('.js-article-nav');

	if ($articleNav.length === 0) return;

	Swiper.use([Scrollbar]);

	$.each($articleNav, function () {
		const $navslider = $(this);
		new Swiper($navslider[0], {
			loop: false,
			slidesPerView: 'auto',
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
		});
	});
}

articleNav.init = function () {
	articleNav.swiperSlider();
}

articleNav.init();


// WEBPACK FOOTER //
// ./scripts/components/article-nav.js